export default function useIsLoading(...objects) {
  return objects.some((object, i) => {
    // console.log(`object ${i}`, object);
    if (!object) return true;
    if (object.hasOwnProperty("isLoading")) {
      if (object.isLoading) return true;
    }
    if (object.hasOwnProperty("hasLoaded")) {
      if (!object.hasLoaded()) return true;
    }
    return false;
  });
}
